import React, {createRef, useState, useContext, useEffect, useRef} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import axios from "axios";
import __ from "lodash";
import moment from "moment";
import parse from 'html-react-parser';
import IdleTimer from "react-idle-timer";
import {withStyles} from "@material-ui/core/styles";
import {Badge, Button, Icon, IconButton, Tooltip, Typography, useMediaQuery, useTheme} from "@material-ui/core";
import {
  Cancel,
  CheckCircle,
  Create,
  DescriptionOutlined,
  Event,
  MonetizationOn,
  FlashOn,
  VisibilityOutlined,
  FlightTakeoff, Email, MoneyOff, AirplanemodeActive, AirplanemodeInactive,
} from "@material-ui/icons";
import {BrowserUpdated, ConnectingAirports, MarkEmailRead, PriceCheck, RequestQuote} from "@mui/icons-material";
import MaterialTable from "@material-table/core";
import {defaultComponentsScroll, MaterialTableBody, MaterialTableSummaryRow, FullWidthFilter} from "../../../controls/Material-Table-Components"
import SystemContext from "../../../SystemContext";
import {getApiSitePrefix} from "../../../functions/SiteDefaults";
import {getDefaultValues, formatDims} from "../../../functions/TemplateHelperFunctions";
import {ColumnWidth, renderBooleanFilter } from "../../../blocks/ColumnHelper";
import useDimensions from "../../../blocks/useDimensions";
import {useSettings} from "../../../services/settings";
import {IconButtonMenu, LightTooltip} from "../../../controls";
import {FreighterUnloading, FreighterUnloadingX, PlaneTicket} from "../../../icons";
import editDialogs from "./BookingQueueList/editDialogs";

import {useBookings, useUpdateBooking, useReviewBooking, useUpdateSlr, useUpdateSpot, useUpdateMultipleBookings, useReassignBooking} from "../../../services/booking";
import useCurrencies from "../../../services/currencies/useCurrencies";
import useExchangeRates from "../../../services/currencies/useExchangeRatesWithName";

import BookingForm from "./BookingForm";
import DocumentViewer from "../../Documents/DocumentViewer";
import {getSearchValues} from "../BookingHelperFunctions";
import {prepareRecordForEditing, setConfirmedSpotRate} from "./BookingRecord";
import FlightSelectionDialog from "./BookingQueueList/FlightSelectionDialog";
import TripConnection from "./BookingQueueList/TripConnection";
import ActualFlownValues from "./ActualFlown";

const apiSitePrefix = getApiSitePrefix();
const FlightBadge = withStyles(theme => ({
  badge: {
    height: 15,
    minWidth: 15,
    borderRadius: 7
  },
  anchorOriginTopRightRectangle: {
    transform: "scale(1) translate(5%, -15%)"
  },
}))(Badge);


// const bookingStatuses = {
//   "PRE-ADVICE": "Pre-Advice",
//   "PRE-BOOKING": "Pre-Booking",
//   "BOOKED": "Booked",
//   "CONFIRMED": "Confirmed",
//   "CANCELLED": "Cancelled",
//   "DELIVERED": "Delivered",
//   "FLIGHT-SUMMARY": "Summary",
//   "IN-TRANSIT": "In Transit",
//   "OFFLOADED": "Offloaded",
//
//   "SPOT": "Spot Booked",
//   "WAREHOUSE": "Received",
//   "SLR-LOADABLE": "SLR Loadable",
//   "SLR-NOT-LOADABLE": "SLR Not Loadable" ,
//   "SLR-ACCEPTED": "SLR Accepted",
//   "SLR-REJECTED": "SLR Rejected",
//   "SPOT-SL-REVIEW": "Spot Loadability Review",
//   "SPOT-SL-LOADABLE": "Spot Loadable",
//   "SPOT-SL-NOT-LOADABLE": "Spot Not Loadable",
//   "SPOT-REJECTED": "Spot Rejected",
//   "SPOT-OFFER": "Spot Offer",
//   "SPOT-ACCEPTED": "Spot Accepted"
// };

const bookingStatuses = [
  {code: "PRE-ADVICE", value: "Pre-Advice", multiASelectActions: ["confirm", "cancel", "review", "rebook"]},
  {code: "PRE-BOOKING", value: "Pre-Booking", multiASelectActions: ["confirm", "cancel", "review", "rebook"]},
  {code: "BOOKED", value: "Booked", multiASelectActions: ["confirm", "cancel", "review", "rebook"]},
  {code: "CANCELLED", value: "Cancelled", multiASelectActions: ["rebook"]},
  {code: "CONFIRMED", value: "Confirmed", multiASelectActions: ["cancel", "review", "rebook"]},

  {code: "WAREHOUSE", value: "Received", multiASelectActions: ["rebook"]},
  {code: "OFFLOADED", value: "Offloaded", multiASelectActions: ["rebook"]},
  {code: "IN-TRANSIT", value: "In Transit", multiASelectActions: ["rebook"]},
  {code: "DELIVERED", value: "Delivered", multiASelectActions: []},
  {code: "FLIGHT-SUMMARY", value: "Summary", multiASelectActions: []},

  {code: "SLR-LOADABLE", value: "SLR Loadable", multiASelectActions: []},
  {code: "SLR-NOT-LOADABLE", value: "SLR Not Loadable", multiASelectActions: []},
  {code: "SLR-ACCEPTED", value: "SLR Accepted", multiASelectActions: []},
  {code: "SLR-REJECTED", value: "SLR Rejected", multiASelectActions: []},

  {code: "SPOT", value: "Spot Booked", multiASelectActions: []},
  {code: "SPOT-SL-REVIEW", value: "Spot Loadability Review", multiASelectActions: []},
  {code: "SPOT-SL-LOADABLE", value: "Spot Loadable", multiASelectActions: []},
  {code: "SPOT-SL-NOT-LOADABLE", value: "Spot Not Loadable", multiASelectActions: []},
  {code: "SPOT-REJECTED", value: "Spot Rejected", multiASelectActions: []},
  {code: "SPOT-OFFER", value: "Spot Offer", multiASelectActions: []},
  {code: "SPOT-ACCEPTED", value: "Spot Accepted", multiASelectActions: []},
];

const Checked = (props) => {
  const state = (props.checked === true)?'check_box':'check_box_outline_blank';
  return <Icon {...props}>{state}</Icon>
}

const hasViewableDocuments = (documents) => {
  if (!documents || !Array.isArray(documents) || documents.length <= 0)
    return false;

  for (let i = 0; i < documents.length; i++) {
    const document = documents[i];
    if (__.has(document, "fileUrl") && document.fileUrl)
      return true;
  }
  return false;
}

const canUpdateActualValues = (bookingRecord) => {
  return moment.utc().isAfter(moment(bookingRecord.scheduledDepartureTime));
}

// ========================================================================
// Main Component Body
// ========================================================================
const BookingQueueList = (_props) => {
  const theme = useTheme();
  const {isAuthenticated} = useAuth0();

  const props = {
    ..._props
  }

  const {classes} = props;
  const operatorName = __.startCase(__.toLower(process.env.REACT_APP_COMPANY)) || "Magma";

  let smallest = useMediaQuery('(min-width: 1680px)');
  let addOneCol = useMediaQuery('(min-width:1980px)');
  let addTwoCols = useMediaQuery('(min-width:2040px)');
  let addThreeCols = useMediaQuery('(min-width:2100px)');
  let addFourCols = useMediaQuery('(min-width:2160px)');

  const [state, setState] = useState({
    activeRow: null,
    selectedIndex: null,
    canEdit: props.canEdit||false,
  });
  const [editBooking, setEditBooking] = useState ({
    open: false,
    bookingRecord: null,
  });
  const [viewDocuments, setViewDocuments] = useState ({
    open: false,
    documentsToView: null,
  });
  const [selectFlight, setSelectFlight] = useState ({
    open: false,
    fromDate: null,
    airportCode: null,
    dialogTitle: null,
    dialogMessage: null,
  });
  const [flownValues, setFlownValues] = useState ({
    open: false,
    bookingRecord: null,
  })
  const [searchExtraKeys, setSearchExtraKeys] = useState (__.has(props, "searchExtraKeys") && props.searchExtraKeys ? props.searchExtraKeys : ["EMPTY_SEARCH"]);

  const searchBookings = __.has(props, "searchBookings") || false;
  const spotBookings = props.spotBookings || false;
  const specialLoads = props.specialLoadRequests || false;
  const customerBookings = __.has(props, "customerBookings") || false;
  const customerData = customerBookings ? props.customerBookings : null;

  let selectedRow = -1;

  const [selectedTripUuid, setSelectedTripUuid] = useState(props.tripUuid);

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  // if (eventBus) {
  //   eventBus.bind('BookingQueueTrips.tripSelected', (tripData)=> {
  //     setSelectedTripUuid(tripData?.tripUuid);
  //   });
  // }

  const getTripLegData = async (tripLegUuid) => {
    try {
      const response = await axios.get(`${apiSitePrefix}/triplegs/getTripLeg/${tripLegUuid}`);
      if (!response.data) {
        SystemData.alert("Error", `Could not retrieve flight information. Server is not responding`);
        return null;
      } else if (!Array.isArray(response.data) || response.data.length < 1) {
        SystemData.alert("Error", `Could not retrieve flight information. Flight not found`);
        return null
      }
      else {
        return response.data[0];
      }
    } catch (err) {
      SystemData.alert("Error", `Could not retrieve flight information. Server is not responding`);
      return null
    }
  }

  const getDefaults = async (path) => {
    const defaults = await getDefaultValues(SystemData, path, "defaults");
    if (!defaults)
      return null;
    return defaults;
  }

  const customerRowActionOptions = [
    {action: "Cancel Booking", itemLabel: "Cancel Booking", itemIcon: <Cancel/>, historySuffix: "", statuses: ["PRE-BOOKING"]},
    {action: "Rebook Cancelled", itemLabel: "Rebook Cancelled", itemIcon: <Event/>, historySuffix: "", statuses: ["CANCELLED"]},
    {action: "Rebook to New Flight", itemLabel: "Rebook to New Flight", itemIcon: <Event/>, historySuffix: "", statuses: ["PRE-BOOKING", "BOOKED", "OFFLOADED", "SPOT", "WAREHOUSE"]},
    (rowData) => {return {action: "Convert to Booking", itemLabel: "Convert to Booking", disabled: rowData.bookingType !== "SPOT" , itemIcon: <PlaneTicket/>, historySuffix: "", statuses: ["SPOT-OFFER", "SPOT-ACCEPTED"]}},
    {action: "Booking Details", itemLabel: "Booking Details", itemIcon: <Create/>, historySuffix: "", statuses: ["ALL"]},
    (rowData) => {return {action: "View Documents", disabled: !hasViewableDocuments(rowData.documents), itemLabel: "View Documents", itemIcon: <DescriptionOutlined/>, historySuffix: "", statuses: ["ALL"]}},
  ];

  const customerSpotRowActionOptions = [
    {action: "Spot Booking Details", itemLabel: "Spot Booking Details", itemIcon: <Create/>, historySuffix: "", statuses: ["ALL"]},
    {action: "Cancel Booking", itemLabel: "Cancel Booking", itemIcon: <Cancel/>, historySuffix: "", statuses: ["PRE-BOOKING"]},
    {action: "Convert to Booking", itemLabel: "Convert to Booking", itemIcon: <PlaneTicket/>, historySuffix: "", statuses: ["SPOT-OFFER", "SPOT-ACCEPTED"]},
    (rowData) => {return {action: "View Documents", disabled: !hasViewableDocuments(rowData.documents), itemLabel: "View Documents", itemIcon: <DescriptionOutlined/>, historySuffix: "", statuses: ["ALL"]}},
  ];

  const rowActionOptions = [
    {action: "Confirm Booking", itemLabel: "Confirm Booking", itemIcon: <CheckCircle/>, historySuffix: "", statuses: ["PRE-BOOKING", "BOOKED"]},
    {action: "Cancel Booking", itemLabel: "Cancel Booking", itemIcon: <Cancel/>, historySuffix: "", statuses: ["CONFIRMED", "OFFLOADED", "PRE-ADVICE", "PRE-BOOKING", "SPOT", "WAREHOUSE"]},
    {action: "Rebook to New Flight", itemLabel: "Rebook to New Flight", itemIcon: <Event/>, historySuffix: "", statuses: ["PRE-BOOKING", "BOOKED", "CONFIRMED", "OFFLOADED", "SPOT", "WAREHOUSE"]}, //TODO: Should pre-booking be allowed for this?
    {action: "Rebook Cancelled", itemLabel: "Rebook Cancelled", itemIcon: <Event/>, historySuffix: "", statuses: ["CANCELLED"]},
    {action: "Booking Details", itemLabel: "Booking Details", itemIcon: <Create/>, historySuffix: "", statuses: ["ALL"]},
    (rowData) => {return {action: "View Documents", disabled: !hasViewableDocuments(rowData.documents), itemLabel: "View Documents", itemIcon: <DescriptionOutlined/>, historySuffix: "", statuses: ["ALL"]}},
    (rowData) => {return {action: "Update Flown Values", itemLabel: "Update Flown Values", disabled: canUpdateActualValues(rowData), itemIcon: <BrowserUpdated/>, historySuffix: "", statuses: ["CONFIRMED"]}},
  ];

  const spotRowActionOptions = [
    {action: "Spot Booking Details", itemLabel: "Spot Booking Details", itemIcon: <Create/>, historySuffix: "", statuses: ["ALL"]},
    {action: "Internal - Review Spot Loadability", itemLabel: "Internal - Review Spot Loadability", itemIcon: <FreighterUnloading/>, historySuffix: "", statuses: ["PRE-BOOKING"]},
    {action: "Internal - Loadability Review Response", itemLabel: "Internal - Loadability Review Response", itemIcon: <FreighterUnloadingX/>, historySuffix: "", statuses: ["PRE-BOOKING", "SPOT-SL-REVIEW"]},
    {action: "Reject Spot - Not Loadable", itemLabel: "Reject Spot - Not Loadable", itemIcon: <FreighterUnloadingX/>, historySuffix: "", statuses: ["SPOT-SL-REVIEW", "SPOT-SL-NOT-LOADABLE"]},
    (rowData) => {return {action: "Counter Offer Target Rate", itemLabel: "Counter Offer Target Rate", disabled: !rowData.offeredSpotRate || rowData.offeredSpotRate === 0 || rowData.spotChargeableWeight && Number(rowData.spotChargeableWeight) === 0 , itemIcon: <RequestQuote/>, historySuffix: "", statuses: ["PRE-BOOKING", "SPOT-SL-LOADABLE"]}},
    {action: "Re-send Offer Target Rate", itemLabel: "Re-send Offer Target Rate", itemIcon: <Email/>, historySuffix: "", statuses: ["SPOT-OFFER"]},
    {action: "Reject Spot Target Rate", itemLabel: "Reject Spot Target Rate", itemIcon: <MoneyOff/>, historySuffix: "", statuses: ["PRE-BOOKING", "SPOT-OFFER"]},
    {action: "Confirm Spot Rate to Customer", itemLabel: "Confirm Spot Rate to Customer", itemIcon: <PriceCheck/>, historySuffix: "", statuses: ["PRE-BOOKING", "SPOT-SL-LOADABLE", "SPOT-OFFER"]},
    {action: "Re-Send Spot Rate Confirmation", itemLabel: "Re-Send Spot Rate Confirmation", itemIcon: <MarkEmailRead/>, historySuffix: "", statuses: ["SPOT-ACCEPTED"]},
    {action: "Convert to Booking", itemLabel: "Convert to Booking", itemIcon: <PlaneTicket/>, historySuffix: "", statuses: ["SPOT-OFFER", "SPOT-ACCEPTED"]},
    (rowData) => {return {action: "View Documents", disabled: !hasViewableDocuments(rowData.documents), itemLabel: "View Documents", itemIcon: <DescriptionOutlined/>, historySuffix: "", statuses: ["ALL"]}},
  ];

  const specialLoadRowActionOptions = [
    (rowData) => {return {action: `Set to ${rowData.slrFeasibility === "BOOKING"?"Feasibility Check":"Confirmed Booking"}`, itemLabel: `Set to ${rowData.slrFeasibility === "BOOKING"?"Feasibility Check":"Confirmed Booking"}`, itemIcon: rowData.slrFeasibility === "BOOKING" ? <AirplanemodeInactive/> : <AirplanemodeActive/>, historySuffix: "", statuses: ["PRE-BOOKING", "PRE-ADVICE", "SLR-LOADABLE"]}},
    {action: "Confirm Loadable", itemLabel: "Confirm Loadable", itemIcon: <CheckCircle/>, historySuffix: "", statuses: ["PRE-BOOKING", "PRE-ADVICE"]},
    {action: "Re-send Loadable Notification", itemLabel: "Re-send Loadable Notification", itemIcon: <Email/>, historySuffix: "", statuses: ["SLR-LOADABLE"]},
    {action: "Assign Special Load to Flight", itemLabel: "Assign Special Load to Flight", itemIcon: <FlightTakeoff/>, historySuffix: "", statuses: ["SLR-LOADABLE"]},
    {action: "Re-send Assign to Flight Notification", itemLabel: "Re-send Assign to Flight Notification", itemIcon: <Email/>, historySuffix: "", statuses: ["SLR-ACCEPTED"]},
    {action: "Reassign to Another Flight", itemLabel: "Reassign to Another Flight", itemIcon: <ConnectingAirports/>, historySuffix: "", statuses: ["SLR-ACCEPTED"]},
    {action: "Reject Special Load", itemLabel: "Reject Special Load", itemIcon: <Cancel/>, historySuffix: "", statuses: ["PRE-BOOKING", "PRE-ADVICE", "SLR-LOADABLE"]},
    {action: "Rescind Special Load Rejection", itemLabel: "Rescind Special Load Rejection", itemIcon: <Cancel/>, historySuffix: "", statuses: ["SLR-REJECTED"]},
    {action: "View Details", itemLabel: "View Details", itemIcon: <Create/>, historySuffix: "", statuses: ["ALL"]},
    // (rowData) => {return {action: "View Documents", disabled: !rowData.documents || !Array.isArray(rowData.documents) || rowData.documents.length <= 0, itemLabel: "View Documents", itemIcon: <DescriptionOutlined/>, historySuffix: "", statuses: ["ALL"]}},
    (rowData) => {return {action: "View Documents", disabled: !hasViewableDocuments(rowData.documents), itemLabel: "View Documents", itemIcon: <DescriptionOutlined/>, historySuffix: "", statuses: ["ALL"]}},
  ];

  const getCommodity = (rowData) => {
    let commodity = "";
    if (rowData.expectedPieces > 0)
      commodity = `${rowData.expectedPieces} x ${rowData.specialLoadName}`;

    return commodity;
  }

  const getDimensions = (rowData) => {
    const dims = [];
    let totalWeight = 0;
    if (rowData.dims && Array.isArray(rowData.dims) && rowData.dims.length > 0) {
      rowData.dims.forEach(item => {
        const pieces = item.pieces;
        const length = item.length;
        const width = item.width;
        const height = item.height;
        totalWeight += item.actualWeight;
        dims.push(`${pieces} x ${length} x ${width} x ${height}`);
      });
      dims.push(`${totalWeight}KG Total Net Weight`)
    } else {
      dims.push(`${rowData.expectedPieces > 0 && rowData.expectedWeightKg > 0 ? `${rowData.expectedPieces} Consolidated - ${rowData.expectedWeightKg}KG Total Net Weight` : ``}`)
    }

    return dims.join(", ");
  }

  async function executeRowAction(params) {
    if (params) {
      const rowData = params.rowData;
      let dialogTitle = "";
      let dialogMessage = "";
      let template = "";
      let newStatus = "";
      switch (params.selectedOption) {
        case "Mark Reviewed":
          // reviewBooking(rowData);
          dialogTitle = params.selectedOption;
          dialogMessage = parse(`Marking the booking as reviewed will remove it from the booking queue until any of its pertinent values are changed again. Are you sure you wish to mark booking of Airway Bill <strong>${rowData.awbNo}</strong> as <strong>'REVIEWED'</strong> for trip <strong>${rowData.tripPrefix}${rowData.tripNo}</strong>?`);
          template = null;
          newStatus = rowData.bookingStatus;
          executeWorkflowActions(handleReviewBooking, rowData, dialogTitle, dialogMessage, template, newStatus, "booking", prepareBookingEmail, rowData.companyName, false, "Mark as Reviewed");
          break;
        case "Confirm Booking":
          // confirmBooking(rowData);
          dialogTitle = params.selectedOption;
          dialogMessage = parse(`Are you sure you wish to <strong>CONFIRM</strong> booking of Airway Bill ${rowData.awbNo}? ${rowData.companyName} will be notified accordingly.`);
          template = "bookingConfirmationTemplate";
          newStatus = "CONFIRMED";
          executeWorkflowActions(handleUpdateBooking, rowData, dialogTitle, dialogMessage, template, newStatus, "booking", prepareBookingEmail, rowData.companyName, false, "Confirm Booking");
          break;
        case "Cancel Booking":
          // cancelBooking(rowData);
          dialogTitle = params.selectedOption;
          dialogMessage = parse(`Are you sure you wish to <strong>CANCEL</strong> booking of Airway Bill ${rowData.awbNo}? ${rowData.companyName} will be notified accordingly.`);
          template = "bookingCancellationTemplate";
          newStatus = "CANCELLED";
          executeWorkflowActions(handleUpdateBooking, rowData, dialogTitle, dialogMessage, template, newStatus, "booking", prepareBookingEmail, rowData.companyName, false, "Cancel Booking");
          break;
        case "Rebook Cancelled":
          dialogTitle = params.selectedOption;
          dialogMessage = parse(`Are you sure you wish to <strong>REBOOK</strong> cancelled booking of Airway Bill ${rowData.awbNo}?`);
          template = null;
          newStatus = "BOOKED";
          executeWorkflowActions(handleUpdateBooking, rowData, dialogTitle, dialogMessage, template, newStatus, "booking", prepareBookingEmail, rowData.companyName, false, "Rebook");
          break;
        case "Rebook to New Flight":
          preBooking(rowData);
          break;
        case "View Details":
        case "Booking Details":
        case "Spot Booking Details":
          setEditBooking({...editBooking, open: true, bookingRecord: prepareRecordForEditing(rowData, exchangeRates.data, currencies.data) });
          break;
        case "View Documents":
          const documents = rowData.documents && Array.isArray(rowData.documents) ? rowData.documents : [];
          const documentsToView = [];
          documents.forEach( document => {
            if (__.has(document, "fileUrl") && document.fileUrl) {
              const documentDetails = {
                documentType: document.documentType,
                documentDescription: document.fileDescription,
                fileName: document.fileName,
                fileType: document.fileType,
                uri: document.fileUrl
              }

              documentsToView.push(documentDetails);
            }
          });
          if (documentsToView.length > 0) {
            setViewDocuments({...setViewDocuments, open: true, documentsToView: documentsToView});
          } else {
            const bookingType = rowData.bookingType === "SPOT" ? "Spot Request" ? rowData.bookingType === "SPECIAL LOAD" : "Special Load Request" : "Booking";
            SystemData.openAlert("No Documents", `There are no documents attached to this ${bookingType}`);
          }
          break;
        case "Update Flown Values":
          setFlownValues({...flownValues,  open: true, bookingRecord: prepareRecordForEditing(rowData, exchangeRates.data, currencies.data), awb: rowData.awbNo });
          break;
        // =========================================
        // SPOT Actions
        // =========================================
        case "Internal - Review Spot Loadability":
          dialogTitle = params.selectedOption;
          dialogMessage = `Send the spot request for review by Special Loads Officer?`;
          template = "spotIsLoadableTemplate";
          newStatus = "SPOT-SL-REVIEW";
          executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, "Special Loads Officer");
          break;
        case "Internal - Loadability Review Response":
          loadingDecision(rowData);
          // dialogTitle = params.selectedOption;
          // dialogMessage = parse(`Inform sales department that the <strong>Spot Request</strong> is not loadable? Sales will follow-up with the customer.`);
          // template = "spotIsLoadableResponseTemplate";
          // newStatus = "SPOT-SL-NOT-LOADABLE";
          // executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, "Special Loads Officer");
          break;
        case "Reject Spot - Not Loadable":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to reject the spot rate Request? ${rowData.companyName} will be notified accordingly.`;
          template = "spotNotLoadableTemplate";
          newStatus = "SPOT-REJECTED";
          executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, rowData.companyName);
          break;
        case "Counter Offer Target Rate":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to send the revised spot rate offer? ${rowData.companyName} will be notified accordingly.`;
          template = "spotOfferTemplate";
          newStatus = "SPOT-OFFER";
          executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, rowData.companyName, true);
          break;
        case "Re-send Offer Target Rate":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to re-send the Spot Rate offer to ${rowData.companyName}?`;
          template = "spotOfferTemplate";
          newStatus = "";
          executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, rowData.companyName, true);
          break;
        case "Reject Spot Target Rate":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to reject spot rate of ${rowData.customerTargetRateRounded} ${rowData.currencyCode} ? ${rowData.companyName} will be notified accordingly.`;
          template = "spotRejectedTemplate";
          newStatus = "SPOT-REJECTED";
          executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, rowData.companyName);
          break;
        case "Confirm Spot Rate to Customer":
          // confirmTargetRate(rowData);
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to confirm spot rate of ${rowData.offeredSpotRateRounded && rowData.offeredSpotRateRounded > 0? rowData.offeredSpotRateRounded : rowData.customerTargetRateRounded} ${rowData.currencyCode} ? ${rowData.companyName} will be notified accordingly.`;
          template = "spotAcceptedTemplate";
          newStatus = "SPOT-ACCEPTED";
          const rates = setConfirmedSpotRate(rowData, exchangeRates.data);
          if (!__.isEmpty(rates)) {
            if (__.has(rates, "charges"))
              rowData["charges"] = rates.charges;
            if (__.has(rates, "eurTotalAmount"))
              rowData["eurTotalAmount"] = rates.eurTotalAmount;
            if (__.has(rates, "gbpTotalAmount"))
              rowData["gbpTotalAmount"] = rates.gbpTotalAmount;
            if (__.has(rates, "usdTotalAmount"))
              rowData["usdTotalAmount"] = rates.usdTotalAmount;
          }
          executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, rowData.companyName, true);
          break;
        case "Re-Send Spot Rate Confirmation":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to re-send the Spot Rate confirmation?`;
          template = "spotAcceptedTemplate";
          newStatus = "";
          executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, rowData.companyName);
          break;
        case "Convert to Booking":
          dialogTitle = params.selectedOption;
          dialogMessage = parse(`Are you sure you wish to convert this Spot Request to a <strong>CONFIRMED</strong> booking?`);
          template = "";
          newStatus = customerBookings ? "BOOKED" : "CONFIRMED";
          executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, rowData.companyName);
          break;
        // =========================================
        // SLR Actions
        // =========================================
        case "Confirm Loadable":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to confirm the SLR is loadable? ${rowData.slrCompanyName} will be notified accordingly.`;
          template = "slrLoadableTemplate";
          newStatus = "SLR-LOADABLE";
          executeWorkflowActions(handleUpdateSlr, rowData, dialogTitle, dialogMessage, template, newStatus, "specialloads", prepareSlrEmail, rowData.slrCompanyName);
          break;
        case "Set to Confirmed Booking":
        case "Set to Feasibility Check":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to flag the SLR as a ${params.selectedOption === "Set to Confirmed Booking" ? "Confirmed Booking" : "Feasibility Check"}?`;
          template = "";
          newStatus = rowData.bookingStatus;
          rowData.slrFeasibility = params.selectedOption === "Set to Confirmed Booking" ? "BOOKING" : "FEASIBILITY";
          rowData["slrFeasibilitySet"] = true;
          executeWorkflowActions(handleUpdateSlr, rowData, dialogTitle, dialogMessage, template, newStatus, "specialloads", prepareSlrEmail, rowData.slrCompanyName, null, "Yes", null, true);
          break
        case "Re-send Loadable Notification":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to re-send the SLR loadable notification?`;
          template = "slrLoadableTemplate";
          newStatus = "";
          executeWorkflowActions(handleUpdateSlr, rowData, dialogTitle, dialogMessage, template, newStatus, "specialloads", prepareSlrEmail, rowData.slrCompanyName);
          break;
        case "Assign Special Load to Flight":
        case "Reassign to Another Flight":
          dialogTitle = params.selectedOption;
          dialogMessage = params.selectedOption === "Reassign to Another Flight" ? "Please select the NEW Flight that will carry the Special Load. The Special Load will be removed from the current flight" : "Please select the Flight that will carry the Special Load";
          setSelectFlight({open: true, rowData, airportCode: rowData.origin, fromDate: rowData.requestedDate, dialogTitle, dialogMessage});
          // onChange of selectFlight dialog calls executeWorkflowActions
          break;
        case "Re-send Assign to Flight Notification":
          dialogTitle = params.selectedOption;
          dialogMessage = `Are you sure you wish to re-send the SLR Assigned to Flight notification?`;
          template = "slrAssignedTemplate";
          newStatus = "";
          const tripLeg = await getTripLegData(rowData.tripLegUuid);
          if (tripLeg) {
            tripLeg["slrCommodity"] = getCommodity(rowData);
            tripLeg["dimensions"] = getDimensions(rowData);
          }
          executeWorkflowActions(handleUpdateSlr, rowData, dialogTitle, dialogMessage, template, newStatus, "specialloads", prepareSlrEmail, rowData.slrCompanyName, tripLeg);
          break;
        case "Reject Special Load":
          dialogTitle = params.selectedOption;
          dialogMessage = parse(`Are you sure you wish to reject the SLR${rowData.bookingStatus === "SLR-LOADABLE" ? "<strong> although customer was informed that the shipment is loadable</strong>" : ""}? ${rowData.slrCompanyName} will be notified accordingly.`);
          template = "slrRejectedTemplate";
          newStatus = "SLR-REJECTED";
          executeWorkflowActions(handleUpdateSlr, rowData, dialogTitle, dialogMessage, template, newStatus, "specialloads", prepareSlrEmail, rowData.slrCompanyName);
          break;
        case "Rescind Special Load Rejection":
          dialogTitle = params.selectedOption;
          dialogMessage = parse(`Are you sure you wish to rescind the previous SLR rejection? <strong> you will need to advise the customer again when the SLR is confirmed as loadable.</strong>`);
          newStatus = "PRE-ADVICE";
          executeWorkflowActions(handleUpdateSlr, rowData, dialogTitle, dialogMessage, null, newStatus, "specialloads", null, rowData.slrCompanyName, null, "Yes", null, true);
          break;
        default:
          break;
      }
    }
  }

  const getRecipientDetails = (contactMethods) => {
    let recipient = "";
    if (contactMethods && Array.isArray(contactMethods)) {
      const email = __.find(contactMethods, "email");
      if (email && __.has(email, "email"))
        return email.email;
    }
    return recipient;
  }

  // additionalData for SPOT is boolean and the values are taken from rowData
  const prepareSpotEmail = (rowData, defaults, template, additionalData, slrReview = false) => {
    const requestedDate = moment(rowData.requestedDate, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY");
    const subject = `${operatorName} Booking Spot Rate Request // ${rowData.spotReference} // ${rowData.origin} - ${rowData.destination} // ${requestedDate}`;
    const internalRecipient = slrReview && template === "spotIsLoadableResponseTemplate" ? (__.has(defaults, "notify") ? defaults.notify : "") : (__.has(defaults, "notifySlrReview") ? defaults.notifySlrReview : "");
    const emailRecord = {
      recipients: slrReview ? internalRecipient : getRecipientDetails(rowData.bookedByContactMethods),
      carbonCopy: template === "spotIsLoadableResponseTemplate" ? (__.has(defaults, "notifySlrReview") ? defaults.notifySlrReview : "") : (__.has(defaults, "notify") ? defaults.notify : ""),
      subject: subject,
      templateType: "SPOT",
      templateUuid: __.has(defaults, template) ? defaults[template] : "",
      spotContactName: `${rowData.bookedByTitle ? rowData.bookedByTitle + " " : ""} ${rowData.bookedByForename ?? ""} ${rowData.bookedBySurname ?? ""}`,
      spotCompanyName: rowData.companyName,
      spotDate: requestedDate,
      spotAwb: `${rowData.awbPrefix && rowData.awbSerial ? `AWB ${rowData.awbPrefix}-${rowData.awbSerial.toString().padStart(8, "0")}` : ``}`,
      spotReference: rowData.spotReference,
      repeatData: [],
    }
    if (__.has(rowData, "loadable")) {
      emailRecord["loadableDecision"] = rowData.loadable;
    }
    if (rowData.loadabilityNotes) {
      emailRecord["loadingNotes"] = rowData.loadabilityNotes;
    }

    const overrideChargeableWeight = rowData.spotChargeableWeight && !isNaN(Number(rowData.spotChargeableWeight)) && Number(rowData.spotChargeableWeight) > 0 && rowData.spotChargeableWeight !== rowData.expectedChargeableWeight;
    if (additionalData) {
      const routing = rowData.viaRouting;
      emailRecord["spotFlight"] =  routing?.departureFlight ?? "";
      emailRecord["origin"] = rowData.origin;
      emailRecord["destination"] = rowData.destination;
      emailRecord["spotFlightDate"] = moment(rowData.requestedDate).format("DD/MMM");
      emailRecord["spotChargeableWeight"] = overrideChargeableWeight ? rowData.spotChargeableWeight : rowData.expectedChargeableWeight;
      emailRecord["spotCustomerTargetRate"] = (rowData.customerTargetRate).toFixed(2);
      emailRecord["spotOfferedRate"] = rowData.offeredSpotRate ? (rowData.offeredSpotRate).toFixed(2) : rowData.customerTargetRate ? (rowData.customerTargetRate).toFixed(2) : "";
      emailRecord["spotCurrency"] = rowData.currencyCode;
      emailRecord["spotExpiryHoursBeforeSTD"] = __.has(defaults, "spotExpiryHoursBeforeSTD") ? defaults["spotExpiryHoursBeforeSTD"] : "72";
      emailRecord["spotExpiry"] = moment(rowData.requestedDate).subtract(Number(emailRecord["spotExpiryHoursBeforeSTD"]), "hours").format("DD/MMM");
    }

    return emailRecord;
  }

  // additionalData for SLR is an object with values for the email message returned from the Flight Selection dialog
  const prepareSlrEmail = (rowData, defaults, template, additionalData) => {
    const requestedDate = moment(rowData.requestedDate, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY");
    const subject = `${operatorName} Special Load Request // ${rowData.slrReference} // ${rowData.origin} - ${rowData.destination} // ${requestedDate}`;
    const emailRecord = {
      recipients: `${rowData.slrContactEmail}`,
      carbonCopy: __.has(defaults, "notify") ? defaults.notify : "",
      subject: subject,
      templateType: "SLR",
      templateUuid: __.has(defaults, template) ? defaults[template] : "",
      slrContactName: rowData.slrContactName,
      slrCompanyName: rowData.slrCompanyName,
      slrDate: requestedDate,
      slrAwb: `${rowData.awbPrefix && rowData.awbSerial ? ` ${rowData.awbPrefix}-${rowData.awbSerial}` : ``}`,
      slrReference: rowData.slrReference,
      slrCommodity: `${rowData.specialLoadName}${rowData.unNumbers ? ` / UN${rowData.unNumbers}` : ``}`,
      repeatData: [],
    }
    if (template === "slrLoadableTemplate" && __.has(defaults, "notifyCommercial")) {
      const currentCcList = emailRecord.carbonCopy.split(",");
      const commercialCcList = defaults.notifyCommercial.split(",");
      const ccList = [...currentCcList, ...commercialCcList];
      emailRecord.carbonCopy = ccList.join(",");
    }
    if (template === "slrAssignedTemplate" && __.has(defaults, "notifyOps")) {
      const currentCcList = emailRecord.carbonCopy.split(",");
      const commercialCcList = defaults.notifyOps.split(",");
      const ccList = [...currentCcList, ...commercialCcList];
      emailRecord.carbonCopy = ccList.join(",");
      if (rowData.documents && Array.isArray(rowData.documents)) {
        const summaryDocument = __.find(rowData.documents, {documentType: "SLR"});
        if (summaryDocument && __.has(summaryDocument, "fileUrl") && summaryDocument.fileUrl !== "") {
          emailRecord["attachment"] = summaryDocument.fileName;
          emailRecord["attachmentUrl"] = summaryDocument.fileUrl;
        }
      }
    }
    if (__.has(rowData, "dims") && rowData.dims) {
      emailRecord["dimensions"] = formatDims(rowData.dims);
    }

    if (additionalData) {
      emailRecord["slrFlight"] = `${additionalData.airlineCode}-${additionalData.flightNo}`;
      emailRecord["origin"] = additionalData.originAirportCode;
      emailRecord["destination"] = additionalData.destinationAirportCode;
      emailRecord["slrFlightDate"] = moment(additionalData.scheduledDepartureTimeUTC).format("DD/MMM");
      // emailRecord["slrCommodity"] = additionalData.slrCommodity;
      emailRecord["slrCommodity"] = `${rowData.specialLoadName}${rowData.unNumbers ? ` / UN${rowData.unNumbers}` : ``}`;
      // emailRecord["dimensions"] = additionalData.dimensions;
    }

    return emailRecord;
  }

  const prepareBookingEmail = (rowData, defaults, template, additionalData, slrReview = false) => {
    const routing = rowData.viaRouting;
    const requestedDate = moment(rowData.requestedDate, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY");
    const subject = `${operatorName} Aviation Booking Request // ${rowData.awbNo} // ${rowData.origin} - ${rowData.destination} // ${routing?.departureFlight ?? ""}`;
    const emailRecord = {
      recipients: getRecipientDetails(rowData.bookedByContactMethods),
      carbonCopy: __.has(defaults, "notify") ? defaults.notify : "",
      subject: subject,
      templateType: "BOOKING",
      templateUuid: __.has(defaults, template) ? defaults[template] : "",
      contactName: `${rowData.bookedByTitle ? rowData.bookedByTitle + " " : ""} ${rowData.bookedByForename ?? ""} ${rowData.bookedBySurname ?? ""}`,
      companyName: rowData.companyName,
      bookingReference: rowData.bookingReference,
      flight: rowData.viaRouting?.departureFlight,
      flightDate: moment(rowData.requestedDate).format("DD/MMM"),
      awb: `${rowData.awbPrefix && rowData.awbSerial ? `${rowData.awbPrefix}-${rowData.awbSerial}` : ``}`,
      grossWeight: rowData.expectedWeightKgRounded,
      chargeableWeight: rowData.expectedChargeableWeightRounded,
      origin: rowData.origin,
      destination: rowData.destination,
      latestAcceptanceTime: __.has(defaults, "latestAcceptanceTime") ? defaults["latestAcceptanceTime"] : "12 hours",
      repeatData: [],
    }

    return emailRecord;
  }

  const sendWorkFlowEmail = async (sendEmail, defaultsPath, emailFunction, rowData, template, companyName, dialogTitle, additionalData) => {
    const defaults = sendEmail ? await getDefaults(defaultsPath) : null;
    if (sendEmail && defaults && template) {
      const emailRecord = emailFunction(rowData, defaults, template, additionalData, companyName === "Special Loads Officer");
      SystemData.sendEmail(emailRecord, `${!dialogTitle?.toLowerCase().includes("send") ? "Send " : ""}${dialogTitle??""} notification ${!dialogTitle?"from":"to"} ${companyName}`, true);
    }
  }

  const sendWorkFlowMessage = async (sendMessage, bookingData) => {
    if (sendMessage) {
      const bookingRecords = Array.isArray(bookingData) ? bookingData : [bookingData];
      const result = await axios.put(`${apiSitePrefix}/bookings/sendbookinconfirmation`, {bookingRecords: bookingRecords});
      if (result && __.has(result, "data")) {
        const data = result.data;
        if (data.errors && Array.isArray(data.errors)) {
          const title = `${data.success ? `Message Send Completed with some Errors` : `Message Send Failed`}`
          SystemData.alert(title, data.errors.join(", "));
        }
      }
    }
  }

  const executeWorkflowActions = async (handler, rowData, dialogTitle, dialogMessage, template, newStatus, defaultsPath, emailFunction, companyName, additionalData = null, yesLabel = "Yes", multiAction = null, silentUpdate = false) => {
    let sendEmail = template && template !== "";
    let sendMessage = Array.isArray(rowData) ? rowData[0].bookingType === 'E-BOOKING' : rowData.bookingType === 'E-BOOKING';
    let checkBoxes = null;
    if (!specialLoads && !spotBookings && !silentUpdate) {
      checkBoxes =
        [
          {label: "Send notification email", value: sendEmail, disabled: template && template === "", onChange: (returnValue)=> {sendEmail = returnValue; } },
          {label: "Send notification message", value: sendMessage, disabled:  Array.isArray(rowData) ? rowData[0].bookingType !== 'E-BOOKING' : rowData.bookingType !== 'E-BOOKING', onChange: (returnValue)=> {sendMessage = returnValue; } },
        ];
    }

    if (dialogTitle && dialogMessage) {
      SystemData.confirm(
        dialogTitle,
        dialogMessage,
        [
          {icon: "check_circle", value: true, label: yesLabel, options: {color:"primary"}},
          {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
        ],
        async (response) => {
          // let sendEmail = template && template !== "";
          if (response) {
            if (newStatus && newStatus !== "") {
              handler.mutate({
                extraKeys,
                record: Array.isArray(rowData) ? {bookingRecords: rowData, multiAction: multiAction} : {...rowData, bookingStatus: newStatus},
                postSuccess: async () => {
                  // SystemData.alert("", `${dialogTitle} completed`);
                  if (!silentUpdate) {
                    await sendWorkFlowMessage(sendMessage, rowData);
                    await sendWorkFlowEmail(sendEmail, defaultsPath, emailFunction, rowData, template, companyName, dialogTitle, additionalData);
                  }
                  queryClient.invalidateQueries("BookingHistory");
                },
                postError: (data) => {
                  sendEmail = false;
                  if (data.errorMessage) {
                    SystemData.alert("Error", `${data.errorMessage}`);
                  } else {
                    SystemData.alert("Error", `An Unexpected Error has occurred updating the record(s).`);
                  }
                }
              });
            } else {
              // Just send the email without updating the booking record.
              await sendWorkFlowEmail(sendEmail, defaultsPath, emailFunction, rowData, template, companyName, dialogTitle, additionalData);
            }
          }
        },
        {checkBoxes: checkBoxes }
      );
    } else {
      if (newStatus && newStatus !== "") {
        handler.mutate({
          extraKeys,
          record: Array.isArray(rowData) ? {bookingRecords: rowData, multiAction: multiAction} : {...rowData, bookingStatus: newStatus},
          postSuccess: async () => {
            await sendWorkFlowMessage(sendMessage, rowData);
            await sendWorkFlowEmail(sendEmail, defaultsPath, emailFunction, rowData, template, companyName, dialogTitle, additionalData);
            queryClient.invalidateQueries("BookingHistory");
          },
          postError: (data) => {
            sendEmail = false;
            if (data.errorMessage) {
              SystemData.alert("Error", `${data.errorMessage}`);
            } else {
              SystemData.alert("Error", `An Unexpected Error has occurred updating the record(s).`);
            }
          }
        });
      } else {
        // Just send the email without updating the booking record.
        await sendWorkFlowEmail(sendEmail, defaultsPath, emailFunction, rowData, template, companyName, dialogTitle, additionalData);
      }
    }
  }

  const actionMultipleConfirms = (selectedRows) => {
    if (selectedRows?.length > 0) {
      const dialogTitle = "Confirm Selected Bookings";
      const dialogMessage = parse(`Are you sure you wish to CONFIRM ${selectedRows.length > 1 ? `all` : ``} <strong>${selectedRows.length}</strong> booking${selectedRows.length > 1 ? `s` : ``}? Customers will be notified accordingly.`);
      const template = null;
      const newStatus = "CONFIRMED";
      executeWorkflowActions(handleMultipleBookings, selectedRows, dialogTitle, dialogMessage, template, newStatus, "booking", prepareBookingEmail, "", false, `Confirm ${selectedRows.length} booking${selectedRows.length > 1 ? `s` : ``}`, "confirm");
    }
  }

  const actionMultipleCancellations = (selectedRows) => {
    if (selectedRows?.length > 0) {
      const dialogTitle = "Cancel Selected Bookings";
      const dialogMessage = parse(`Are you sure you wish to <strong>CANCEL</strong> ${selectedRows.length > 1 ? `all` : ``} <strong>${selectedRows.length}</strong> booking${selectedRows.length > 1 ? `s` : ``}? Customers will be notified accordingly.`);
      const template = null;
      const newStatus = "CANCELLED";
      executeWorkflowActions(handleMultipleBookings, selectedRows, dialogTitle, dialogMessage, template, newStatus, "booking", prepareBookingEmail, "", false, `Cancel ${selectedRows.length} booking${selectedRows.length > 1 ? `s` : ``}`, "cancel");
    }
  }

  const actionMultipleReviews = (selectedRows) => {
    if (selectedRows?.length > 0) {
      const dialogTitle = "Mark Selected Bookings as Reviewed";
      const dialogMessage = parse(`Are you sure you wish to <strong>mark</strong> ${selectedRows.length > 1 ? `all` : ``} <strong>${selectedRows.length}</strong> booking${selectedRows.length > 1 ? `s` : ``} as reviewed? Reviewed bokings will be removed from this list.`);
      const template = null;
      const newStatus = "REVIEWED";
      executeWorkflowActions(handleMultipleBookings, selectedRows, dialogTitle, dialogMessage, template, newStatus, "booking", prepareBookingEmail, "", false, `Mark ${selectedRows.length} booking${selectedRows.length > 1 ? `s` : ``} as reviewed`, "review");
    }
  }

  const actionMultipleRebookings = (selectedRows) => {
    if (selectedRows?.length > 0) {
      let originMatch = true;
      let destinationMatch = true;
      let origin = null;
      let destination = null;
      for(let i = 0; i < selectedRows.length; i++) {
        const row = selectedRows[i];
        if (!origin && !destination) {
          origin = row.origin;
          destination = row.destination;
        }
        if (origin !== row.origin) {
          originMatch = false;
          break;
        }
        if (destination !== row.destination) {
          destinationMatch = false;
          break;
        }
      }

      if (!originMatch || !destinationMatch) {
        SystemData.alert("Origin/Destination mismatch", `Rebooking of multiple items is only possible if all bookings have the same origin and destination`);
        return;
      }

      // TODO: Implement this
      // const dialogTitle = "Mark Selected Bookings as Reviewed";
      // const dialogMessage = parse(`Are you sure you wish to <strong>mark</strong> ${selectedRows.length > 1 ? `all` : ``} <strong>${selectedRows.length}</strong> booking${selectedRows.length > 1 ? `s` : ``} as reviewed? Reviewed bokings will be removed from this list.`);
      // const template = null;
      // const newStatus = "REVIEWED";
      // executeWorkflowActions(handleMultipleBookings, selectedRows, dialogTitle, dialogMessage, template, newStatus, "booking", prepareBookingEmail, "", false, `Mark ${selectedRows.length} booking${selectedRows.length > 1 ? `s` : ``} as reviewed`, "review");
    }
  }

  const actionLoadableReviewDecision = (rowData, decision, notes) => {
    const dialogTitle = null;
    const dialogMessage = null;
    const template = "spotIsLoadableResponseTemplate";
    const newStatus = decision === "LOADABLE" ? "SPOT-SL-LOADABLE" : "SPOT-SL-NOT-LOADABLE";
    executeWorkflowActions(handleUpdateSpot, rowData, dialogTitle, dialogMessage, template, newStatus, "spotrequests", prepareSpotEmail, "Special Loads Officer");
  }

  const selectionAllowed = (rowData) => {
    if (specialLoads)
      return false;

    if ( ! ["PRE-BOOKING", "BOOKED", "CONFIRMED", "CANCELLED"].includes(rowData.bookingStatus))
      return false;

    if (tableRef.current) {
      const data = tableRef.current.dataManager.data;
      if (data && Array.isArray(data)) {
        let selectedBookingStatus = null;
        let selectedTripLegUuid = null;
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          if (__.has(item.tableData, "checked") && item.tableData.checked) {
            selectedBookingStatus = item.bookingStatus;
            selectedTripLegUuid = item.tripLegUuid;
            break;
          }
        }
        if (selectedBookingStatus) {
          return (rowData.bookingStatus === selectedBookingStatus && rowData.tripLegUuid === selectedTripLegUuid);
        }
      }
      return true;
    }
  }


  const handleRowClick = (event, rowData) => {
    if (rowData.tableData.id >= 0) {
      selectedRow = rowData.tableData.id;
      if (eventBus) {
        eventBus.trigger('BookingQueueList.rowSelected', rowData);
      }
    }
  }

  const renderActionIcon = (rowData) => {
    if (spotBookings) {
      return (
        <MonetizationOn style={{width:24, height:24 }} color={(state.canEdit && tableRef.current?.state?.selectedCount === 0 ? (rowData.tableData.id === selectedRow ? 'secondary' : 'primary') : 'disabled')}/>
      );
    }
    if (specialLoads)
      return (
        <FreighterUnloading style={{width:24, height:24 }} color={(state.canEdit && tableRef.current?.state?.selectedCount === 0 ? (rowData.tableData.id === selectedRow ? 'secondary' : 'primary') : 'disabled')}/>
      );
    return (
      <PlaneTicket style={{width:24, height:24 }} color={(state.canEdit && tableRef.current?.state?.selectedCount === 0 ? (rowData.tableData.id === selectedRow ? 'secondary' : 'primary') : 'disabled')}/>
    );
  }

  // useEffect(() => {
  //   const handleResize = __.debounce(()=>{
  //     setResizing(!resizing);
  //     if (resizing) setTimeout(()=> {setResizing(false)}, 1000);
  //   }, 1000, {leading: true, trailing: true});

  //   window.addEventListener('resize', handleResize);

  //   return ()=> {window.removeEventListener('resize', handleResize);}
  // },[resizing]);

  const tableRef = createRef({state: {lastEditingRow: false}});

  const handleUpdateBooking = useUpdateBooking();
  const handleReviewBooking = useReviewBooking();
  const handleUpdateSlr = useUpdateSlr();
  const handleUpdateSpot = useUpdateSpot();
  const handleMultipleBookings = useUpdateMultipleBookings();
  const handleReassignBooking = useReassignBooking();


  const queryClient = useQueryClient();
  let extraKeys = searchBookings ? searchExtraKeys : spotBookings ? (!customerBookings ? ["SPOT"] : [customerData.gsaCompanyUuid, "SPOT"]) : specialLoads ? ["SLR", props.fromDate, props.toDate] : customerBookings ? [customerData.gsaCompanyUuid, "ALL"] : [selectedTripUuid || props.selectedTripUuid || " "];
  const queuedBookings = useBookings({tableRef, queryClient, extraKeys});

  const rateExtraKeys = ["SYSTEM", moment().format("YYYY-MM-DD")];
  const currencies = useCurrencies(tableRef, queryClient, []);
  const exchangeRates = useExchangeRates({tableRef, queryClient, extraKeys: rateExtraKeys});
  const terms = useSettings({tableRef, queryClient, extraKeys: ["TERMS"]});

  // const {reviewBooking, confirmBooking, cancelBooking, preBooking, confirmTargetRate, showBookingSummary, dialogBoxes} = editDialogs(SystemData, apiSitePrefix, extraKeys, handleUpdateBooking, handleUpdateBooking, handleReviewBooking, formatChars);
  const {preBooking, showBookingSummary, loadingDecision, dialogBoxes} = editDialogs(SystemData, apiSitePrefix, extraKeys, handleReassignBooking, actionLoadableReviewDecision);

  useEffect(() => {
    const setSearchValues = (params) => {
      setSearchExtraKeys(getSearchValues(params));
    }

    if (eventBus) {
      eventBus.bind('BookingQueue.search', setSearchValues);
    }
    return () => {
      eventBus.unbind('BookingQueue.search', setSearchValues);
    }
  }, [eventBus]);


  useEffect(() => {

    const getTripSummary = () => {
      let bookingSummary = [];

      if (queuedBookings && queuedBookings.data && Array.isArray(queuedBookings.data)) {
        queuedBookings.data.sort(function(a, b) {
          const destinationA = a.destination.toUpperCase(); // ignore upper and lowercase
          const destinationB = b.destination.toUpperCase(); // ignore upper and lowercase
          if (destinationA < destinationB) {
            return -1;
          }
          if (destinationA > destinationB) {
            return 1;
          }

          // destinations must be equal
          return 0;
        });

        let tripNumber = "";
        let lastDestination = "";
        queuedBookings.data.forEach(booking => {
          if (booking.bookingStatus !== "CANCELLED") {
            if (tripNumber === "" && booking.tripPrefix && booking.tripNo)
              tripNumber = booking.tripPrefix + booking.tripNo;
            if (booking.destination !== lastDestination) {
              lastDestination = booking.destination;

              //Average Yield for destination
              if (bookingSummary.length > 0) {
                const revenue = bookingSummary[bookingSummary.length - 1].revenue;
                const weight = bookingSummary[bookingSummary.length - 1].weight;
                bookingSummary[bookingSummary.length - 1].yield = weight && weight > 0 ? revenue / weight : 0;
              }

              // New destination
              const destinationTotals = {destination: booking.destination, weight: 0, chargeableWeight: 0, volume: 0, revenue: 0, yield: 0};
              bookingSummary.push(destinationTotals);
            }

            const destinationTotals = bookingSummary[bookingSummary.length - 1];
            const weight = booking.expectedWeightKgRounded.replace(/,/g, '');
            const cWeight = booking.expectedChargeableWeightRounded.replace(/,/g, '');
            const volume = booking.expectedVolumeRounded.replace(/,/g, '');
            // const revenue = booking.usdAmountRounded.replace(/,/g, '');
            const revenue = booking.bookedUsdAmountRounded.replace(/,/g, '');

            destinationTotals["weight"] += weight ? Number(weight) : 0;
            destinationTotals["chargeableWeight"] += cWeight ? Number(cWeight) : 0;
            destinationTotals["volume"] += volume ? Number(volume) : 0;
            destinationTotals["revenue"] += revenue ? Number(revenue) : 0;
          }
        });

        //Average Yield for last destination
        if (bookingSummary.length > 0) {
          const revenue = bookingSummary[bookingSummary.length - 1].revenue;
          const weight = bookingSummary[bookingSummary.length - 1].weight;
          bookingSummary[bookingSummary.length - 1].yield = weight && weight > 0 ? revenue / weight : 0;
        }

        const tripTotals = {weight: 0, chargeableWeight: 0, volume: 0, revenue: 0, yield: 0};
        bookingSummary.forEach(destinationTotals => {
          tripTotals.weight += destinationTotals.weight.round(1);
          tripTotals.chargeableWeight += destinationTotals.chargeableWeight.round(1);
          tripTotals.volume += destinationTotals.volume.round(1);
          tripTotals.revenue += destinationTotals.revenue.round(2);
          tripTotals.yield += destinationTotals.yield.round(4);

          destinationTotals.weight = destinationTotals.weight.round(1).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1});
          destinationTotals.chargeableWeight = destinationTotals.chargeableWeight.round(1).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1});
          destinationTotals.volume = destinationTotals.volume.round(1).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1});
          destinationTotals.revenue = destinationTotals.revenue.round(2).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
          destinationTotals.yield = destinationTotals.yield.round(4).toLocaleString(undefined, {minimumFractionDigits: 4, maximumFractionDigits: 4});
        })

        tripTotals.yield = bookingSummary.length > 0 ? tripTotals.yield / bookingSummary.length : 0;
        tripTotals.weight = tripTotals.weight.round(1).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1});
        tripTotals.chargeableWeight = tripTotals.chargeableWeight.round(1).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1});
        tripTotals.volume = tripTotals.volume.round(1).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1});
        tripTotals.revenue = tripTotals.revenue.round(2).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        tripTotals.yield = tripTotals.yield.round(4).toLocaleString(undefined, {minimumFractionDigits: 4, maximumFractionDigits: 4});

        showBookingSummary(bookingSummary, tripTotals, tripNumber);
      }
    }

    if (eventBus) {
      eventBus.bind('BookingQueueTrips.tripSummaryRequested', getTripSummary);
    }
    return () => {
      eventBus.unbind('BookingQueueTrips.tripSummaryRequested', getTripSummary);
    }
  }, [eventBus, queuedBookings, queuedBookings.data, showBookingSummary]);

  const renderFlightNumber = (rowData) => {
    if (__.has(rowData, "flightNo") && !__.isEmpty(rowData.flightNo)) {
      return `${rowData.airlineCode}-${rowData.flightNo} ${moment.utc(rowData.scheduledDepartureTimeUTC).format("DD MMM HH:mm")} ${rowData.originAirportCode}-${rowData.destinationAirportCode}`
    }

    return rowData.viaRouting?.departureFlight;
  }

  const renderBadgedFlight = (rowData) => {
    const flights = rowData.viaRouting?.flights;
    const departureFlight = rowData.viaRouting?.departureFlight;
    const fullRouting = departureFlight ? departureFlight.substring(departureFlight.indexOf("(")) : null;
    const numberOfFlights = fullRouting ? (fullRouting.match(/-/g) || []).length : null;

    return(
      <LightTooltip title={rowData.viaRouting?.departureFlight}>
        <FlightBadge style={{}} badgeContent={numberOfFlights && numberOfFlights > 1 ? numberOfFlights : null} color={"primary"}>
          <span>{renderFlightNumber(rowData)}</span>
        </FlightBadge>
      </LightTooltip>
    )
  }

  const highlightChangedValue = (column, rowData, value, cellStyle) => {
    const color = (rowData?.bookingType === "SPECIAL LOAD" || customerBookings) ? undefined : rowData?.changes && __.has(rowData?.changes, column) ? "#DAA520" : undefined;
    return ({...cellStyle, backgroundColor: color });
  }

  const getColumns = (tableWidth) => {
    const baseColumn = {
      cellStyle: { fontSize:11, padding: "4px 2px" },
      headerStyle: { padding: "4px 2px" },
      filterCellStyle: { padding: "4px 2px" },
      editable: "never",
      sorting: false,
      resizable: false,
    };
    const borderedCellStyle = { fontSize: 11, padding: "4px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "1px solid #f5f5f5" };
    const boldBorderedCellStyle = { fontSize: 12, fontWeight: 800, padding: "4px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "1px solid #f5f5f5" };
    const invisibleBorderedCellStyle = { fontSize: 11, padding: "4px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "1px solid #ffffff" };
    const boldInvisibleBorderedCellStyle = { fontSize: 12, fontWeight: 800, padding: "4px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "1px solid #ffffff" };
    const borderedHeaderStyle = { borderLeft: "0px solid rgb(63, 63, 63)", borderRight: "1px solid rgb(63, 63, 63)", padding: "4px 2px 6px 2px"};
    const borderedFilterStyle = {}; //{ borderLeft: "0px solid #ffffff", borderRight: "1px solid #ffffff" };

    return [
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */
      {
        ...baseColumn,
        ...ColumnWidth(80, 1, undefined, {...borderedCellStyle, borderLeft: "1px solid #f5f5f5"}, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Trip",
        field: "tripNumber",
        hidden: (!__.isEmpty(selectedTripUuid) && selectedTripUuid !== "CHANGES") ||  spotBookings || specialLoads || customerBookings,
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <span>{rowData.tripNumber}</span>
          )
          return (
            // <LightTooltip title={rowData.tripRoute}>
            //   <span>{rowData.tripNumber}</span>
            // </LightTooltip>
            <LightTooltip title={<TripConnection bookingUuid={rowData.bookingUuid}/>}>
              <span>{rowData.tripNumber}</span>
            </LightTooltip>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(125, 1, undefined, {...borderedCellStyle, borderLeft: "1px solid #f5f5f5"}, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Flight",
        field: "viaRouting",
        hidden: specialLoads,
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <span>{rowData.viaRouting?.departureFlight ? rowData.viaRouting?.departureFlight.slice(0, rowData.viaRouting?.departureFlight.indexOf("(")) : ""}</span>
          )
          return (renderBadgedFlight(rowData))
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(110, 1, undefined, {...borderedCellStyle, borderLeft: "1px solid #f5f5f5"}, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Spot",
        field: "spotReference",
        hidden: !spotBookings,
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <span>{rowData.spotReference}</span>
          )
          return (
            <span>{rowData.spotReference}</span>
          )
        }
      },
      {
        ...baseColumn,
        ...(ColumnWidth(32, 1, undefined, {...borderedCellStyle, padding: "8px 0px 4px"}, {paddingLeft:6}, undefined, false)),
        title: "Bkd",
        field: "slrFeasibility",
        type: "boolean",
        hidden: !specialLoads,
        // summarise: (rowData => rowData.stackableStatus?1:0),
        defaultFilter: undefined, // 'checked', 'unchecked', or undefined
        filterComponent: (props) => renderBooleanFilter({...props, size: "small"}),
        cellStyle: (value, rowData) => { return highlightChangedValue("slrFeasibility", rowData, value, borderedCellStyle);},
        render: rowData => <Checked style={{padding: "0px 8px"}} checked={rowData.slrFeasibility === "BOOKING"} value="true" fontSize="small"/>,
      },
      {
        ...baseColumn,
        ...ColumnWidth(100, 1, undefined, {...borderedCellStyle, borderLeft: "1px solid #f5f5f5"}, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Reference",
        field: "slrReference",
        hidden: !specialLoads,
        filterComponent: FullWidthFilter,
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <span>{rowData.slrReference}</span>
          )
          return (
            <LightTooltip title={rowData.tripRoute}>
              <span>{rowData.slrReference}</span>
            </LightTooltip>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(40, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Date",
        field: "tripDateDDMMM",
        filtering: false,
        hidden: !__.isEmpty(selectedTripUuid) && selectedTripUuid !== "CHANGES",
        // render: rowData => (
        //     <span>{rowData.tripDateDDMMM}</span>
        // )
      },
      {
        ...baseColumn,
        ...ColumnWidth(24, 1, undefined, invisibleBorderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "",
        field: "bookingType",
        filtering: false,
        render: rowData => {
          return ( (rowData.bookingType === "E-BOOKING") ? <FlashOn /> : <></>  );
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(80, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Status",
        field: "bookingStatus",
        filterComponent: FullWidthFilter,
        cellStyle: (value, rowData) => {
          return highlightChangedValue("bookingStatus", rowData, value, {...borderedCellStyle, fontWeight: "800"});
        },
        render: rowData => {
          return (
            <div>
              { (!rowData.bookingStatus)
                ? ""
                : __.find(bookingStatuses, {code: rowData.bookingStatus})?.value || "Invalid"
              }
            </div>);
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(120, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: specialLoads ? "Client" : "GSA",
        field: specialLoads ? "slrCompanyName" : "companyName",
        filterComponent: FullWidthFilter,
        hidden: customerBookings,
        cellStyle: (value, rowData) => {
          return highlightChangedValue("companyName", rowData, value, borderedCellStyle);
        },
        render: rowData => (
          <LightTooltip title={ `${specialLoads ? `Request by ${rowData.slrContactName} (${rowData.slrContactEmail}) of ${rowData.slrCompanyName}` : rowData.companyName}` }>
            <div style={{width: 120, maxWidth: 120, minWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
              {specialLoads && rowData.slrCompanyName ? rowData.slrCompanyName : rowData.companyName}
            </div>
          </LightTooltip>
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Origin",
        field: "origin",
        filterComponent: FullWidthFilter,
        cellStyle: (value, rowData) => {
          return highlightChangedValue("origin", rowData, value, borderedCellStyle);
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Dest.",
        field: "destination",
        filterComponent: FullWidthFilter,
        cellStyle: (value, rowData) => {
          return highlightChangedValue("destination", rowData, value, {...borderedCellStyle, fontWeight: "800"});
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(90, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "AWB",
        field: "awbNo",
        hidden: specialLoads,
        filterComponent: FullWidthFilter,
        cellStyle: (value, rowData) => {
          return highlightChangedValue("awbNo", rowData, value, borderedCellStyle);
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(90, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Commodity",
        field: "commodity",
        hidden: specialLoads,
        filterComponent: FullWidthFilter,
        cellStyle: (value, rowData) => {
          return highlightChangedValue("commodity", rowData, value, borderedCellStyle);
        },
        render: rowData => {
          if (rowData.tableData.isScrolling) return (
            <div style={{width: 90, maxWidth: 90, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
              {rowData.commodity}
            </div>
          )
          return (
            <LightTooltip title={rowData.commodity}>
              <div style={{width: 90, maxWidth: 90, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                {rowData.commodity}
              </div>
            </LightTooltip>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(180, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Special Load",
        field: "specialLoadCode",
        hidden: !specialLoads,
        filterComponent: FullWidthFilter,
        cellStyle: (value, rowData) => {
          return highlightChangedValue("specialLoadCode", rowData, value, borderedCellStyle);
        },
        render: rowData => {
          if (rowData.tableData.isScrolling) return (
            <div style={{width: 180, maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
              {rowData.specialLoadName}
            </div>
          )
          return (
            <LightTooltip title={rowData.specialLoadName}>
              <div style={{width: 180, maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                {rowData.specialLoadName}
              </div>
            </LightTooltip>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(32, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "PCs",
        field: "expectedPieces",
        type: "numeric",
        summarise: rowData => rowData?.bookingStatus !== "CANCELLED",
        summariseProps: {decimalScale:0},
        filtering: false,
        cellStyle: (value, rowData) => {
          return highlightChangedValue("expectedPieces", rowData, value, borderedCellStyle);
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "WT",
        field: "expectedWeightKgRounded",
        type: "numeric",
        filtering: false,
        summarise: rowData => rowData?.bookingStatus !== "CANCELLED" ? rowData?.expectedWeightKg?.round(2) : 0,
        summariseProps: {decimalScale:0, fixedDecimalScale: true},
        cellStyle: (value, rowData) => {
          return highlightChangedValue("expectedWeightKg", rowData, value, borderedCellStyle);
        },
//        render: rowData=>(<>{rowData.expectedWeightKgRounded}</>)
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "CWT",
        field: "expectedChargeableWeightRounded",
        type: "numeric",
        filtering: false,
        summarise: (rowData => rowData?.bookingStatus !== "CANCELLED" ? rowData?.expectedChargeableWeight?.round(2) : 0),
        summariseProps: {decimalScale:0, fixedDecimalScale: true},
        cellStyle: (value, rowData) => {
          return highlightChangedValue("expectedChargeableWeight", rowData, value, borderedCellStyle);
        },
//        render: rowData => (<>{rowData.expectedChargeableWeightRounded}</>)
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "SCWT",
        field: "spotChargeableWeightRounded",
        type: "numeric",
        filtering: false,
        hidden: !spotBookings,
        summarise: (rowData => rowData?.bookingStatus !== "CANCELLED" ? Number(rowData?.spotChargeableWeight) : 0),
        summariseProps: {decimalScale:0, fixedDecimalScale: true},
        cellStyle: (value, rowData) => {
          return highlightChangedValue("spotChargeableWeight", rowData, value, borderedCellStyle);
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "CBM",
        field: "expectedVolumeRounded",
        type: "numeric",
        filtering: false,
        summarise: (rowData => rowData?.bookingStatus !== "CANCELLED" ? rowData?.expectedVolume?.round(2) : 0),
        summariseProps: {decimalScale:2, fixedDecimalScale: true},
        cellStyle: (value, rowData) => {
          return highlightChangedValue("expectedVolume", rowData, value, borderedCellStyle);
        },
//        render: rowData => (<>{rowData.expectedVolumeRounded}</>)
      },
      {
        ...baseColumn,
        ...(ColumnWidth(32, 1, undefined, {...borderedCellStyle, padding: "8px 0px 4px"}, {paddingLeft:6}, undefined, false)),
        title: "Stk",
        field: "stackableStatus",
        type: "boolean",
        hidden: spotBookings,
        // summarise: (rowData => rowData.stackableStatus?1:0),
        defaultFilter: undefined, // 'checked', 'unchecked', or undefined
        filterComponent: (props) => renderBooleanFilter({...props, size: "small"}),
        cellStyle: (value, rowData) => { return highlightChangedValue("stackableStatus", rowData, value, borderedCellStyle);},
        render: rowData => <Checked style={{padding: "0px 8px"}} checked={rowData.stackableStatus === true || rowData.stackableStatus === 1} value="true" fontSize="small"/>,
        summaryRender: (summaryRowData) => (<div style={{textAlign: "right"}}>{summaryRowData.stackableStatus}</div>)
      },
      {
        ...baseColumn,
        ...(ColumnWidth(32, 1, undefined, {...borderedCellStyle, padding: "8px 0px 4px"}, {paddingLeft:6}, undefined, false)),
        title: "Tilt",
        field: "tiltableStatus",
        type: "boolean",
        hidden: spotBookings,
        defaultFilter: undefined, // 'checked', 'unchecked', or undefined
        filterComponent: (props) => renderBooleanFilter({...props, size: "small"}),
        cellStyle: (value, rowData) => { return highlightChangedValue("tiltableStatus", rowData, value, borderedCellStyle);},
        render: rowData => <Checked style={{padding: "0px 8px"}} checked={rowData.tiltableStatus === true || rowData.tiltableStatus === 1} value="true" fontSize="small"/>
      },
      {
        ...baseColumn,
        ...(ColumnWidth(32, 1, undefined, {...borderedCellStyle, padding: "8px 0px 4px"}, {paddingLeft:6}, undefined, false)),
        title: "Crt",
        field: "cratedStatus",
        type: "boolean",
        hidden: spotBookings,
        defaultFilter: undefined, // 'checked', 'unchecked', or undefined
        filterComponent: (props) => renderBooleanFilter({...props, size: "small"}),
        cellStyle: (value, rowData) => { return highlightChangedValue("cratedStatus", rowData, value, borderedCellStyle);},
        render: rowData => <Checked style={{padding: "0px 8px"}} checked={rowData.cratedStatus === true || rowData.cratedStatus === 1} value="true" fontSize="small"/>
      },
      {
        ...baseColumn,
        ...(ColumnWidth(32, 1, undefined, {...borderedCellStyle, padding: "8px 0px 4px"}, {paddingLeft:6}, undefined, false)),
        title: "DG",
        field: "containsDangerousGoods",
        type: "boolean",
        hidden: spotBookings,
        defaultFilter: undefined, // 'checked', 'unchecked', or undefined
        filterComponent: (props) => renderBooleanFilter({...props, size: "small"}),
        cellStyle: (value, rowData) => { return highlightChangedValue("containsDangerousGoods", rowData, value, borderedCellStyle);},
        render: rowData => <Checked style={{padding: "0px 8px"}} checked={rowData.containsDangerousGoods === true || rowData.containsDangerousGoods === 1} value="true" fontSize="small"/>
      },
      {
        ...baseColumn,
        ...(ColumnWidth(32, 1, undefined, {...borderedCellStyle, padding: "8px 0px 4px"}, {paddingLeft:6}, undefined, false)),
        title: "CAO",
        field: "caoStatus",
        type: "boolean",
        hidden: spotBookings,
        defaultFilter: undefined, // 'checked', 'unchecked', or undefined
        filterComponent: (props) => renderBooleanFilter({...props, size: "small"}),
        cellStyle: (value, rowData) => { return highlightChangedValue("caoStatus", rowData, value, borderedCellStyle);},
        render: rowData => <Checked style={{padding: "0px 8px"}} checked={rowData.caoStatus === true || rowData.caoStatus === 1} value="true" fontSize="small"/>
      },
      {
        ...baseColumn,
        ...(ColumnWidth(32, 1, undefined, {...borderedCellStyle, padding: "8px 0px 4px"}, {paddingLeft:6}, undefined, false)),
        title: "MD",
        field: "deckRequired",
        type: "boolean",
        hidden: spotBookings,
        defaultFilter: undefined, // 'checked', 'unchecked', or undefined
        filterComponent: (props) => renderBooleanFilter({...props, size: "small"}),
        cellStyle: (value, rowData) => { return highlightChangedValue("deckRequired", rowData, value, borderedCellStyle);},
        render: rowData => <Checked style={{padding: "0px 8px"}} checked={rowData.deckRequired === "MAIN"} value="true" fontSize="small"/>
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Target Rate",
        field: "customerTargetRateRounded",
        type: "numeric",
        filtering: false,
        hidden: !spotBookings,
        cellStyle: (value, rowData) => { return boldBorderedCellStyle },
//        render: rowData => Math.round((rowData.rate + Number.EPSILON) * 10000) / 10000
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 1, undefined, borderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "Offer Rate",
        field: "offeredSpotRateRounded",
        type: "numeric",
        filtering: false,
        hidden: !spotBookings,
        render: rowData => rowData?.offeredSpotRateRounded > 0 ? rowData?.offeredSpotRateRounded : "N/A",
        cellStyle: (value, rowData) => { return boldBorderedCellStyle },
//        render: rowData => Math.round((rowData.rate + Number.EPSILON) * 10000) / 10000
      },
      {
        ...baseColumn,
        ...ColumnWidth(60),
        title: "Rate",
        field: "rateRounded",
        type: "numeric",
        filtering: false,
        hidden: !addOneCol || spotBookings || specialLoads,
        cellStyle: (value, rowData) => { return highlightChangedValue("rate", rowData, value,  { fontSize: 11, padding: "4px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "0px solid #ffffff" });},
//        render: rowData => Math.round((rowData.rate + Number.EPSILON) * 10000) / 10000
      },
      {
        ...baseColumn,
        ...ColumnWidth(40, 1, undefined, undefined, undefined, undefined, false),
        title: "",
        field: "currencyCode",
        filtering: false,
        hidden: !addOneCol || spotBookings || specialLoads,
        cellStyle: (value, rowData) => { return highlightChangedValue("rate", rowData, value,  invisibleBorderedCellStyle);},
      },
      {
        ...baseColumn,
        ...ColumnWidth(60, 1, undefined, borderedCellStyle, undefined, undefined, false),
        title: "EUR",
        field: "eurAmountRounded",
        type: "numeric",
        summarise: true,
        summariseProps: {decimalScale:2},
        filtering: false,
        hidden: !addTwoCols || spotBookings || specialLoads,
//        render: rowData => (Math.round((rowData.eurAmount + Number.EPSILON) * 100) / 100).toLocaleString()
      },
      {
        ...baseColumn,
        ...ColumnWidth(60, 1, undefined, borderedCellStyle, undefined, undefined, false),
        title: "USD",
        field: "usdAmountRounded",
        type: "numeric",
        summarise: true,
        summariseProps: {decimalScale:2},
        filtering: false,
        hidden: !addThreeCols || spotBookings || specialLoads,
//        render: rowData => (Math.round((rowData.usdAmount + Number.EPSILON) * 100) / 100).toLocaleString()
      },
      {
        ...baseColumn,
        ...ColumnWidth(60, 1, undefined, borderedCellStyle, undefined, undefined, false),
        title: "GBP",
        field: "gbpAmountRounded",
        type: "numeric",
        summarise: true,
        summariseProps: {decimalScale:2},
        filtering: false,
        hidden: !addFourCols || spotBookings || specialLoads,
//        render: rowData => (Math.round((rowData.gbpAmount + Number.EPSILON) * 100) / 100).toLocaleString()
      },
      {
        ...baseColumn,
//        headerStyle: { padding: "8px 2px 44px" },
        title: "Cargo Desc.",
        field: "cargoDescription",
        hidden: spotBookings,
        filterComponent: FullWidthFilter,
        //cellStyle:{padding:"4px 2px", width: "50%"},
        cellStyle: (value, rowData) => { return highlightChangedValue("cargoDescription", rowData, value, { fontSize: 11, width: "50%", padding: "4px 1px", borderLeft: "0px solid #f5f5f5", borderRight: "1px solid #f5f5f5" });},
        filterCellStyle: {width: "50%", padding: "4px 1px"},
        render: rowData => {
          const lastCol =  specialLoads ? true : document.querySelector('tr th:nth-last-of-type(2)');
          const headerWidth = isNaN((lastCol ? lastCol.clientWidth - 10 : 0)) ? 240 : Math.min((lastCol ? lastCol.clientWidth - 10 : 0), 240);
          // console.log("header", headerWidth, "lastCol", lastCol.clientWidth);
          if (!rowData?.tableData?.isScrolling) {
            return (
              <LightTooltip title={rowData.cargoDescription}>
                <div style={{width: (headerWidth), maxWidth: (headerWidth), overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                  {rowData.cargoDescription}
                </div>
              </LightTooltip>
            )
          }
          return (
            <div style={{width: (headerWidth), maxWidth: (headerWidth), overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
              {rowData.cargoDescription}
            </div>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(10, 1, undefined, invisibleBorderedCellStyle, borderedHeaderStyle, borderedFilterStyle, false),
        title: "",
        field: "",
        hidden: !spotBookings,
        filtering: false,
      },
      {
        ...baseColumn,
        title: "Confirm Target Rate",
        field: "targetRateRounded",
        hidden: !spotBookings,
        filtering: false,
        render: (rowData)=> {
          const lastCol =  specialLoads ? true : document.querySelector('tr th:nth-last-of-type(2)');
          const headerWidth = isNaN((lastCol ? lastCol.clientWidth - 10 : 0)) ? 440 : Math.min((lastCol ? lastCol.clientWidth - 10 : 0), 440);
          const rate = rowData.offeredSpotRateRounded && rowData.offeredSpotRateRounded > 0 ? rowData.offeredSpotRateRounded : rowData.customerTargetRateRounded && rowData.customerTargetRateRounded > 0 ? rowData.customerTargetRateRounded : null;
          const rateAndCurrency =  rate ? `${rate} ${rowData.currencyCode}` : "";
          if (rateAndCurrency !== "") {
            const acceptedStatuses = ["SPOT-ACCEPTED", "CONFIRMED"];
            const loadingReviewStatuses = ["SPOT-SL-NOT-LOADABLE", "SPOT-SL-REVIEW"];
            if (!customerBookings) {
              return(
                <div style={{width: (headerWidth), maxWidth: (headerWidth), overflow: "hidden", textOverflow: "ellipsis"}}>
                  <Button
                    onClick={()=>{executeRowAction({selectedOption: "Confirm Spot Rate to Customer", rowData});}}
                    disabled={!state.canEdit || tableRef.current?.state?.selectedCount > 0 || acceptedStatuses.includes(rowData.bookingStatus) || loadingReviewStatuses.includes(rowData.bookingStatus)}
                    variant= {`${acceptedStatuses.includes(rowData.bookingStatus) || loadingReviewStatuses.includes(rowData.bookingStatus) ? `text` : `outlined`}`}
                    size="small"
                    color={(state.canEdit && tableRef.current?.state?.selectedCount === 0 ? (rowData.tableData.id === selectedRow ? 'secondary' : 'primary') : 'disabled')}
                  >
                    {`${acceptedStatuses.includes(rowData.bookingStatus) ? `Spot rate of ${rateAndCurrency} per Kg of chargeable weight accepted`: `Confirm ${rowData.offeredSpotRateRounded && rowData.offeredSpotRateRounded > 0 ? `offer` : `target`} rate of ${rateAndCurrency} per Kg of chargeable weight`}`}
                  </Button>
                </div>
              );
            } else {
              return(
                <div style={{width: (headerWidth), maxWidth: (headerWidth), overflow: "hidden", textOverflow: "ellipsis"}}>
                  <>{`${loadingReviewStatuses.includes(rowData.bookingStatus)
                      ? `Spot rate of ${rateAndCurrency} is undergoing loadability review`
                      : acceptedStatuses.includes(rowData.bookingStatus)
                        ? `Spot rate of ${rateAndCurrency} per Kg of chargeable weight accepted`
                        : `${rowData.offeredSpotRateRounded && rowData.offeredSpotRateRounded > 0? `Received spot rate offer` : `Requested target spot rate`} of ${rateAndCurrency} per ${rowData.spotChargeableWeightRounded}Kg of chargeable weight`}`
                    }
                  </>
                </div>
              )
            }
          }
          return null;
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(44),
        title: "",
        field: "bookingUuid",
        filtering: false,
        render: (rowData)=> {
          const rowActions = (spotBookings ? (customerBookings ? [...customerSpotRowActionOptions] : [...spotRowActionOptions]) : specialLoads ? [...specialLoadRowActionOptions] :  customerBookings ? customerRowActionOptions : [...rowActionOptions]).map(item => {
            if (typeof item === "function") {
              return item(rowData);
            }
            return item;
          });

          __.remove(rowActions, function(item) {
              return (!item.statuses.includes(rowData.bookingStatus) && !item.statuses.includes("ALL"));
            }
          );
          if (rowData.changes && !__.isEmpty(rowData.changes) && !specialLoads && !customerBookings) {
            rowActions.unshift({action: "Mark Reviewed", itemLabel: "Mark Reviewed", itemIcon: <VisibilityOutlined/>, historySuffix: ""});
          }
          return(
            <IconButtonMenu
              style={{ color: theme.palette.primary.main }}
              hidden={false}
              disabled={!state.canEdit || tableRef.current?.state?.selectedCount > 1}
              //icon={<PlaneTicket style={{width:24, height:24 }} color={(state.canEdit && !state.multipleSelectionActive ? (rowData.tableData.id === selectedRow ? 'secondary' : 'primary') : 'disabled')}/>}
              icon={renderActionIcon(rowData)}
              size={"small"}
              offset={-1}
              tooltip={"Booking Actions"}
              menuItems={rowActions}
              callback={executeRowAction}
              callbackParams={{rowData: rowData}}
            />
          )
        },
        // filterComponent: (props)=> {
        //   return(
        //     <Tooltip title={`Confirm Selected Bookings ${tableRef.current?.state?.selectedCount > 1 ? "" : " - select two or more booking to enable"}`}>
        //       <span>
        //         <IconButton
        //           hidden={spotBookings}
        //           disabled={!state.canEdit || tableRef.current?.state?.selectedCount === 0}
        //           size={"small"}
        //           offset={-1}
        //           onClick={(e)=>{actionMultipleConfirms()}}
        //           style={{margin: "4px 0px 0px 12px"}}
        //         >
        //           <CheckCircle color={`${tableRef.current?.state?.selectedCount > 1 ?"primary":"disabled"}`}/>
        //         </IconButton>
        //       </span>
        //     </Tooltip>
        //   )
        // }
      }
    ];
  };

  const [tableContainerRef, { width: tableWidth, height: tableHeight}] = useDimensions({});

  const selectedRowsData = createRef();

  const theader = tableContainerRef.current?.querySelector('thead');
  const thead = theader ? theader.clientHeight:46;
  const bodyHeight = tableHeight - thead - (specialLoads || spotBookings ? 0 : 64);


  const idleTimer = useRef(null);
  let interval = null;
  const onActive = () => {
    console.log('active');
    if (interval) {
      clearInterval(interval);
    }
  }
  const onIdle = () => {
    console.log('inactive');
    interval = setInterval(()=> {
      console.log('invalidating', extraKeys);
      queryClient.invalidateQueries(['Bookings',...extraKeys]);
    },60*1000);
  }

  useEffect(()=> {
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderSelectionCountTitle = () => {
    if (tableRef.current?.state?.selectedCount) {
      let selectedRows = 0;
      let bookingStatus = null;
      const data = tableRef.current.dataManager.data;
      if (data && Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          if (__.has(item.tableData, "checked") && item.tableData.checked) {
            selectedRows++;
            bookingStatus = __.find(bookingStatuses, {code: item.bookingStatus})?.value;
          }
        }
      }
      return `${selectedRows} '${bookingStatus}' Booking record${selectedRows > 1 ? `s` : ``} selected`
    }
  }

  const hideMultiSelectAction = (bookingStatus, action) => {
    const statusInfo = __.find(bookingStatuses, {code: bookingStatus});
    if (statusInfo && statusInfo.multiASelectActions.includes(action))
      return false;
    return true;
  }

  return (isAuthenticated &&
    <div style={{width: "100%", marginLeft: 20, position: "relative"}}>
      <div style={{background: "#ffffff", paddingTop: 16, paddingLeft: 20, paddingRight: 4, nowidth: "calc(100% - 24px)"}}>
        <div ref={tableContainerRef} className={state.canEdit?classes.bookingQueueListEdit:classes.bookingQueueList} style={{width: "100%", minWidth: "100%", height: `calc(100vh - ${props.height + 16}px)`}}>
          <MaterialTable
            icons={{ Filter: React.forwardRef((props, ref) => <Icon className="filterIcon">filter_list</Icon> )}}
            tableRef={tableRef}
            style={{
              border: "none", //"1px solid #aaaaaa",
              boxShadow: "none",
              borderRadius: 0,
            }}
            onRowClick={handleRowClick}
            options={{
              highlightRowStyle: {backgroundColor: "#F69259"},
              actionsColumnIndex: -1,
              cellStyle: {
                padding: "4px 2px",
              },
              filterCellStyle: {
                padding: "4px 2px",
              },
              headerRowStyle: {
                display: "table",
                width: "100%",
              },
              headerStyle: {
                backgroundColor: theme.palette.tableHeader.backgroundColor,
                color: theme.palette.tableHeader.textColor,
                padding: 2,
              },
              filterRowStyle: {
                paddingLeft: state.canEdit && !specialLoads ? 30 : 0,
                width: state.canEdit ? "calc(100% - 45px)" : "100%",
              },
              toolbar: !specialLoads && !spotBookings && queuedBookings?.data?.length > 0,
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              padding: 'dense',
              paging: false,
              filtering: true,
              search: false,
              searchFieldAlignment: "left",
              columnResizable: false,
              selection: state.canEdit && !specialLoads,
              selectionProps: rowData => {
                return ({ disabled: !selectionAllowed(rowData) })
              },
              // disableSelection: rowData => {
              //   const confirmOption = __.find(rowActionOptions, {action: "Confirm Booking"});
              //   const selectionAllowed =  confirmOption && confirmOption.statuses.includes(rowData.bookingStatus);
              //   return !selectionAllowed;
              // }
            }}
            components={{
              ...defaultComponentsScroll,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={bodyHeight}
                  headerHeight={thead - 8}
                  filterRowHeight={55}
                />
              ),
              SummaryRow: specialLoads? undefined : MaterialTableSummaryRow,
              Action: _props => {
                let props = {..._props};
                if (typeof props.action.action === "function") {
                  props.action = {..._props.action, ..._props.action.action(_props.data)};
                }
                if (props.action.hidden)
                  return <></>
                if (["confirm", "cancel", "review", "rebook"].includes(props.action.icon)) {
                  return (
                    <Tooltip title={props.action.tooltip}>
                      <Button
                        style={{height: 24, marginLeft: 10}}
                        variant="contained"
                        color="primary"
                        startIcon={<Icon>{props.action.startIcon}</Icon>}
                        className={classes.button}
                        onClick={() => {
                          props.action.onClick(props.data)
                        }}
                        disabled={props.action.disabled}
                      >
                        {props.action.text}
                      </Button>
                    </Tooltip>
                  )
                } else if (props.action.icon) {
                  if (props.action.tooltip) {
                    return (<Tooltip title={props.action.tooltip}><IconButton {...__.pick(props.action, ['onClick', 'style', 'color', 'disabled'])}><Icon>{props.action.icon}</Icon></IconButton></Tooltip>)
                  }
                  return (<IconButton {...__.pick(props.action, ['onClick', 'style', 'color', 'disabled'])}><Icon>{props.action.icon}</Icon></IconButton>)
                }
              }
            }}
            actions={[
              (rowData) => ({
                icon: "confirm",
                text: "Confirm Bookings",
                tooltip: "Confirm Multiple Booking",
                // disabled: !state.canEdit || rowData[0].bookingStatus === "CONFIRMED",
                hidden: tableRef.current?.state?.selectedCount === 0 || hideMultiSelectAction(rowData[0].bookingStatus, "confirm"),
                startIcon: "check_circle",
                onClick: actionMultipleConfirms,
              }),
              (rowData) => ({
                icon: "cancel",
                text: "Cancel Bookings",
                tooltip: "Cancel Multiple Booking",
                // disabled: !state.canEdit || rowData[0].bookingStatus === "CONFIRMED",
                hidden: tableRef.current?.state?.selectedCount === 0 || hideMultiSelectAction(rowData[0].bookingStatus, "cancel"),
                startIcon: "cancel",
                onClick: actionMultipleCancellations,
              }),
              (rowData) => ({
                icon: "review",
                text: "Mark as Reviewed",
                tooltip: "Mark Multiple Bookings as Reviewed",
                // disabled: !state.canEdit || rowData[0].bookingStatus === "CONFIRMED",
                hidden: selectedTripUuid !== "CHANGES" || tableRef.current?.state?.selectedCount === 0 || hideMultiSelectAction(rowData[0].bookingStatus, "review"),
                startIcon: "visibility_outlined",
                onClick: actionMultipleReviews,
              }),
              (rowData) => ({
                icon: "rebook",
                text: "Rebook",
                tooltip: "Rebook Multiple Booking",
                // disabled: !state.canEdit || rowData[0].bookingStatus === "CONFIRMED",
                hidden: tableRef.current?.state?.selectedCount === 0 || hideMultiSelectAction(rowData[0].bookingStatus, "rebook"),
                startIcon: "event",
                onClick: actionMultipleRebookings,
              }),
            ]}
            localization={{
              header: {
                actions: 'Action'
              },
              toolbar: {
                // nRowsSelected: `{0} row(s) selected`,
                nRowsSelected: renderSelectionCountTitle,
              }
            }}
            title={selectedTripUuid === "CHANGES" ? "New and Changed Bookings": "Booking List"}
            columns={getColumns(tableWidth)}
            data={queuedBookings.data}
          />
        </div>
      </div>
      {editBooking.open
        ?
          <BookingForm
            record={editBooking.bookingRecord}
            canEdit={state.canEdit}
            newBooking={false}
            spotBooking={spotBookings}
            // formMode: GSA - for GSA bookings (does not require GSA selection), OPERATOR - for system operator bookings (requires GSA selection), SLR - for Special Load Requests
            formMode={specialLoads ? "SLR" : customerBookings ? "GSA" : "OPERATOR"}
            captureParticipants={spotBookings || !editBooking.bookingRecord.forwarderCompanyUuid ? false : true}
            close={()=>{setEditBooking({open: false, rowData: null})}}
            classes={classes}
            exchangeRates={exchangeRates.data}
            currencies={currencies}
            terms={terms.data}
            dialogStates={{showDialog: editBooking.open, awb: editBooking.bookingRecord.awbNo, gsaCompanyUuid: editBooking.bookingRecord.gsaCompanyUuid}}
            defaults={props.defaults}
          />
        : <></>
      }
      {viewDocuments.open
        ?
          <DocumentViewer
            dialogStates={
              {showDialog: viewDocuments.open,
                title: `Documents Viewer for`, //   `Documents Viewer for ${editBooking.bookingRecord.awbNo}`,
                record: viewDocuments.documentsToView[0]
              }
            }
            close={()=>{setViewDocuments({...viewDocuments, open: false})}}
            documents={viewDocuments.documentsToView}
          />
        :
          <></>
      }
      {selectFlight.open
        ?
          <FlightSelectionDialog
            open={selectFlight.open}
            airportCode={selectFlight.rowData.origin}
            fromDate={selectFlight.rowData.requestedDate}
            dialogTitle={selectFlight.dialogTitle}
            dialogMessage={selectFlight.dialogMessage}
            onChange={(returnObject) => {
              if (returnObject && __.has(returnObject, "found") && returnObject.found) {
                const data = returnObject.data;
                const dialogTitle = `Assign SLR to ${data.airlineCode}-${data.flightNo}`;
                const dialogMessage = `Are you sure you wish to assign the the SLR to flight ${data.airlineCode}-${data.flightNo} departing ${data.originAirportCode} on ${moment(data.scheduledDepartureTimeUTC).format("DD/MMM")}, destination ${data.destinationAirportCode}? ${selectFlight.rowData.slrCompanyName} will be notified accordingly.`;
                const template = "slrAssignedTemplate";
                const newStatus = "SLR-ACCEPTED";
                // update rowData so if the record is saved it will have the flightLeg info
                selectFlight.rowData["tripUuid"] = data.tripUuid;
                selectFlight.rowData["tripLegUuid"] = data.tripLegUuid;
                executeWorkflowActions(handleUpdateSlr, selectFlight.rowData, dialogTitle, dialogMessage, template, newStatus, "specialloads", prepareSlrEmail, selectFlight.rowData.slrCompanyName, data);
              }
              setSelectFlight({...selectFlight, open: false, rowData: null, dialogTitle: null, dialogMessage: null});
            }}
          >
          </FlightSelectionDialog>
        :
          <></>
      }
      {flownValues.open
        ?
          <ActualFlownValues
            open={flownValues.open}
            awb={flownValues.bookingRecord.awbNo}
            bookingRecord={flownValues.bookingRecord}
            onChange={(updatedBooking) => {
              if (updatedBooking) {
                const dialogTitle = "Confirm flown values";
                const dialogMessage = parse(`Save the updated flown values?`);
                const template = null;
                const newStatus = updatedBooking.bookingStatus;
                  executeWorkflowActions(handleUpdateBooking, updatedBooking, dialogTitle, dialogMessage, template, newStatus, "booking", null, updatedBooking.companyName, false, "Update", false,  true);
              }
              setFlownValues({...flownValues, open: false, bookingRecord: null, awbNo: null});
            }}
          />
        :
          <></>
      }
      {dialogBoxes}
      {/*<IdleTimer*/}
      {/*  ref={idleTimer}*/}
      {/*  onActive={onActive}*/}
      {/*  onIdle={onIdle}*/}
      {/*  debounce={250}*/}
      {/*  timeout={10 * 1000}*/}
      {/*/>*/}
    </div>
  );

}

export default BookingQueueList;
